import React, { useState, useEffect } from 'react';
import { getAuditoria } from '../services/api';

function Auditoria() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [buscar, setBuscar] = useState('');

  useEffect(() => {
    getAuditoria().then(res => { setLogs(res.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const filtrados = logs.filter(l =>
    l.accion?.toLowerCase().includes(buscar.toLowerCase()) ||
    l.usuario?.toLowerCase().includes(buscar.toLowerCase())
  );

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#64748b' }}>Cargando...</div>;

  return (
    <div>
      <div style={{ marginBottom: 18 }}>
        <input placeholder="Buscar por acción o usuario..." value={buscar} onChange={e => setBuscar(e.target.value)}
          style={{ padding: '8px 12px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', outline: 'none', width: 320 }} />
      </div>

      <div style={{ background: 'white', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
        <div style={{ padding: '18px 22px', borderBottom: '1px solid #f1f5f9' }}>
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>Registro de Auditoría ({filtrados.length})</h3>
        </div>
        <div style={{ padding: '8px 0', maxHeight: 600, overflowY: 'auto' }}>
          {filtrados.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>No hay registros</div>
          ) : filtrados.map(l => (
            <div key={l.id} style={{ padding: '12px 22px', borderBottom: '1px solid #f1f5f9', display: 'flex', gap: 14, alignItems: 'flex-start' }}>
              <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#0d2461', marginTop: 5, flexShrink: 0 }} />
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, color: '#334155' }}>{l.accion}</div>
                <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>
                  {l.usuario} — {new Date(l.fecha).toLocaleDateString('es-DO')} a las {l.hora}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Auditoria;